export default (node) => {
  const howToSelectModalButton = node;
  const howToSelectModal = node.nextElementSibling;

  const modalCloseButton = howToSelectModal.querySelector(
    '[data-how-to-select-close]'
  );

  const openModal = () => {
    howToSelectModal.classList.remove('hidden');
    howToSelectModal.classList.add('flex');
  };

  const closeModal = () => {
    howToSelectModal.classList.remove('flex');
    howToSelectModal.classList.add('hidden');
  };

  const init = () => {
    howToSelectModalButton.addEventListener('click', openModal);
    modalCloseButton.addEventListener('click', closeModal);
    howToSelectModal.addEventListener('click', (e) => {
      if (e.target === howToSelectModal) {
        closeModal();
      }
    });
  };

  init();
};
